
<div style="height:100%;height:100vh;width:100vw;margin:0;padding:0;">
    <!-- <textarea style="width:100%;height:250px;font-size:12px;">{{ translate | json }}</textarea> -->
    <div class="topbar" *ngIf="team" style="position:absolute;width:100%;top:0;left:0;height:30px;">
        <span class="float-right">
            <span translate>GENERIC.UPLOADS</span> {{ uploads.length }} | 
            <span translate>GENERIC.PROCESSING</span> {{ processing.length }} | 

            <a routerLinkActive="yellow" [routerLink]="['files','folder','root']"><span translate>GENERIC.FILES</span></a> | 
            <a routerLinkActive="yellow" [routerLink]="['project']"><span translate>GENERIC.PROJECTS</span></a>
        </span>
        <h4>
            <select #teamPicker (change)="setTeam(teamPicker.value)">
                <option *ngFor="let cur of teams" [value]="cur.uid" [selected]="cur == team">{{cur.name}}</option>
            </select>
        </h4>
    </div>

    <router-outlet></router-outlet>

    <!-- <div class="loading" *ngIf="!team">
        <h1 translate>GENERIC.LOADING</h1>
    </div> -->

</div>